export class Effect {
  constructor(scene, x, y, atlas, animKey, flipX = false) {
    this.markedForRemoval = false;
    const effectDepth = 1200 + y;
    this.sprite = scene.add.sprite(x, y, atlas)
      .setDepth(effectDepth)
      .setFlipX(flipX);
    this.sprite.play(animKey);
    this.sprite.on("animationcomplete", () => {
      this.sprite.destroy();
      this.markedForRemoval = true;
    });
  }
}
